<template>
  <section class="viewsrhqyClockManage_CollectionForm p-4 space-y-4">
    <viewTitle title="业务管理 / 发货打卡管理 / 预约送货收集" :showReturn="false" />
    <div class="flex flex-wrap items-center gap-2">
      <el-form :inline="true" :model="queryParam" class="search-form-inline-small">
        <el-form-item>
          <el-input clearable v-model="queryParam.unit_name" placeholder="输入供应商" class="w-60"></el-input>
        </el-form-item>
        <el-form-item label="送货时间">
          <el-date-picker class="!w-96" v-model="timeRange" type="datetimerange" align="right" unlink-panels
            range-separator="至" :default-time="['00:00:00', '23:59:59']" start-placeholder="开始日期" end-placeholder="结束日期"
            :picker-options="pickerOptions" value-format="timestamp"></el-date-picker>
        </el-form-item>
        <el-form-item label="送货基地" v-if="baseInfo.is_main_com === 1">
          <el-select clearable v-model="queryParam.delivery_com_id">
            <el-option v-for="item in com_list" :key="item.com_id" :label="item.com_name" :value="item.com_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="refreshData" size="small">刷新数据</el-button>
          <el-button @click="onReset" size="small">重置</el-button>
        </el-form-item>
      </el-form>
      <el-button type="primary" v-has="['c-clock-collect-export']" @click="onExport" size="small">
        批量导出
      </el-button>
    </div>
    <c-table class="mt-4" :isIndex="false" :isSelection="false" :data="dataSource" :columns="columns"
      :query.sync="pagintion" :total="total" row-key="id" @loadPage="loadData">
      <template slot="delivery_time" slot-scope="{ row }">
        {{ row.delivery_time | timeFormat("YYYY-MM-DD") }}
      </template>
      <template slot="create_day" slot-scope="{ row }">
        {{ row.create_time | timeFormat("YYYY-MM-DD") }}
      </template>
      <template slot="create_time" slot-scope="{ row }">
        {{ row.create_time | timeFormat("HH:mm:ss") }}
      </template>
    </c-table>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import initListMinxin from "@/mixins/jl/initListMinxin";
export default {
  props: [""],

  data() {
    return {
      fetchDataEvent: params => {
        return this.$common.http({
          url: "/api/queue/admin/query_delivery_collect",
          data: {
            ...params,
            delivery_begin_time: params.begin_time,
            delivery_end_time: params.end_time
          }
        });
      },
      exportDataEvent: params => {
        return this.$common.http({
          url: "/api/queue/admin/export_delivery_collect",
          data: params,
          noLoading: true
        })
      },
      columns: [
        { label: "账号", prop: "account" },
        { label: "供应商编号", prop: "unit_code" },
        { label: "供应商名称", prop: "unit_name" },
        { label: "送货日期", prop: "delivery_time" },
        { label: "送货基地", prop: "delivery_com_name" },
        { label: "车辆数目", prop: "delivery_car_num" },
        { label: "提交日期", prop: "create_day" },
        { label: "提交时间", prop: "create_time" }
      ]
    };
  },
  computed: {
    ...mapGetters(["baseInfo"])
  },
  mixins: [initListMinxin]
};
</script>
